<template><div><h1 id="eb-mehrwertsteuer-korrektur-journal" tabindex="-1"><a class="header-anchor" href="#eb-mehrwertsteuer-korrektur-journal"><span>EB-Mehrwertsteuer-Korrektur-Journal</span></a></h1>
<p>EB-Mehrwertsteuer-Korrektur-Journal — Korrektur-Betrag für die einzelnen Kto/Kst/Ktr/MWST-Kombinationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aus Warenverkauf- und Warenrücknahme-Buchungen (EB-Typen: A, AS, W, WS), die den eingegebenen Parametern entsprechen UND bei denen die Auswertung der Kombination &quot;Konto/Kostenstelle/Kostenträger/MWST&quot; in der Einzelbuchung sich unterscheidet von der aktuell aus dem Artikelstamm ausgewerteten Kombination. Der Korrektur-Betrag für die einzelnen Kto/Kst/Ktr/MWST-Kombinationen kann angeschaut werden im Teil &quot;Rekapitulation pro Konto&quot;.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → EB-Kontoauszüge → EB-Mehrwertsteuer-Korrektur-Journal</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<ul>
<li>
<p>von Journalnummer:
: Muss-Eingabe, inklusive</p>
</li>
<li>
<p>bis:
: Muss-Eingabe, Journalnummer, inklusive</p>
</li>
<li>
<p>von Datum:
: von Belegdatum: ? = unbegrenzt, inklusive</p>
</li>
<li>
<p>bis:
: bis Belegdatum: ? = unbegrenzt, inklusive</p>
</li>
<li>
<p>Mandanten:
: mit Kommas trennen, mit ! ausschliessen, * alle</p>
</li>
<li>
<p>nur mit Merkmal:
: nur Einzelbuchungen für Adressen mit [Merkmal] werden verarbeitet</p>
</li>
</ul>
<dl>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
<dt>Bildschirm:</dt>
<dd>ja</dd>
<dt>Drucker/Format:</dt>
<dd>A4 quer</dd>
<dt>Hintergrundverarb.:</dt>
<dd>ja</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>- AdrNum:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>- FaktNum:</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>- T:</td>
<td>Einzelbuchungstyp</td>
</tr>
<tr>
<td>- Betrag:</td>
<td>Einzelbuchungsbetrag</td>
</tr>
<tr>
<td>- AKonto:</td>
<td>Altes Konto aus der Einzelbuchung</td>
</tr>
<tr>
<td>- NKonto:</td>
<td>Neues Konto aus der Auswertung des Artikelstammes</td>
</tr>
<tr>
<td>- AKst:</td>
<td>Alte Kostenstelle aus der Einzelbuchung</td>
</tr>
<tr>
<td>- NKst:</td>
<td>Neue Kostenstelle aus der Auswertung des Artikelstammes</td>
</tr>
<tr>
<td>- AKtr:</td>
<td>Alter Kostenträger aus der Einzelbuchung</td>
</tr>
<tr>
<td>- Nktr:</td>
<td>Neuer Kostenträger aus der Auswertung des Artikelstammes</td>
</tr>
<tr>
<td>- AM:</td>
<td>Alter MWST-Code aus der Einzelbuchung</td>
</tr>
<tr>
<td>- NM:</td>
<td>Neuer MWST-Code aus der Auswertung des Artikelstammes</td>
</tr>
<tr>
<td>- M:</td>
<td>* = Differenz aus altem MWST-Code und neuem MWST-Code</td>
</tr>
<tr>
<td>Rekapitulation pro Konto:</td>
<td>Rekapitulation pro Konto:</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>- Mandant:</td>
<td>Mandant</td>
</tr>
<tr>
<td>- Kto:</td>
<td>Konto</td>
</tr>
<tr>
<td>- Kst:</td>
<td>Kostenstelle</td>
</tr>
<tr>
<td>- Ktr:</td>
<td>Kostenträger</td>
</tr>
<tr>
<td>- M:</td>
<td>MWST-Code</td>
</tr>
<tr>
<td>- num:</td>
<td>Total Anzahl korrigierter Buchungen pro Kombination Kto/Kst/Ktr/MWST</td>
</tr>
<tr>
<td>- Soll:</td>
<td>Total Korrekturbetrag im Soll pro Kombination Kto/Kst/Ktr/MWST</td>
</tr>
<tr>
<td>- Haben:</td>
<td>Total Korrekturbetrag im Haben pro Kombination Kto/Kst/Ktr/MWSt</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>- Total:</td>
<td>Summe pro Konto für die Spalten [num], [Soll], [Haben]</td>
</tr>
<tr>
<td>- Total:</td>
<td>Summe des Berichts für die Spalten [num], [Soll], [Haben]</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                11.11.1998 14:13:57 pav  Seite     0</span>
<span class="line"> </span>
<span class="line">                      EB-Mehrwertsteuer-Korrektur Journal</span>
<span class="line"></span>
<span class="line">                Achtung: Programm braucht 132 Zeichen / Zeile</span>
<span class="line"></span>
<span class="line">                 von Journalnummer:   1003     bis:   1003</span>
<span class="line">                 von Datum........: 01.01.1998 bis:</span>
<span class="line">                 Mandanten........: \*</span>
<span class="line">                 Testseitenanzahl.: 0</span>
<span class="line"></span>
<span class="line">     AdrNum FaktNum T           Betrag AKonto          NKonto       AKst</span>
<span class="line"> NKst         AKtr        Nktr        AM NM M</span>
<span class="line"> ---------- ------- -- --------------- --------------- ------------ ------------</span>
<span class="line"> ------------ ----------- ----------- -- -- -</span>
<span class="line">          3 2002222 W            23.45 3206.1          3206.1       7907         7907         9700        9700        1  2  \*</span>
<span class="line">          3 2002290 A            23.45 3206.1          3206.1       7907</span>
<span class="line"> .</span>
<span class="line"> Rekapitulation pro Konto</span>
<span class="line"></span>
<span class="line"> Mandant Kto          Kst          Ktr          M      num       Soll      Haben</span>
<span class="line"> ------- ------------ ------------ ------------ - -------- ---------- ----------</span>
<span class="line"> H       3202.3       7990         9700         2       55      45.10       0.00</span>
<span class="line">                                                  -------- ---------- ----------</span>
<span class="line">                                                        55      45.10       0.00</span>
<span class="line">                         Total</span>
<span class="line">                                                  -------- ---------- ----------</span>
<span class="line">                                                        55      45.10       0.00</span>
<span class="line"> Total</span>
<span class="line"></span>
<span class="line"> .</span>
<span class="line">                                                  -------- ---------- ----------</span>
<span class="line">                                                       220    2275.15    2275.15</span>
<span class="line"> Total</span>
<span class="line"></span>
<span class="line"> Kto               num       Soll</span>
<span class="line"> ------------ -------- ----------</span>
<span class="line"> NoInf.              2     -25.80</span>
<span class="line"> -------------------------------------------------------------------------------</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Für die Kombination Kto/Kst/Ktr/MWST 3202.2/7990/9700/2 wurden 55 korrigierte Buchungen gefunden, mit einer Gesamtsumme von Fr. 45.10.</p>
</div></template>


